import { getAccountRole } from './getAccountRole';

import { ROLE_NAME } from 'enums';
import { IAccountUserResponse } from 'services/account/account.interface';
import { IUserManagementUser } from 'views/pages/ManageOrganization/UserManagement/user-management.interface';

function convertToUserManagementTable(
  accounts: IAccountUserResponse[],
): IUserManagementUser[] {
  return accounts
    .filter(account => account?.role.name !== ROLE_NAME.UNAPPROVED)
    .map(
      ({
        email,
        firstName,
        lastName,
        id,
        role,
        position,
        targetPosition,
        expertise,
        department,
        unit,
        requestStatus,
      }) => ({
        email,
        name: `${firstName} ${lastName}`,
        id,
        position: position ? position.name : '-',
        positionId: position?.id,
        targetPosition: targetPosition ? targetPosition.name : '-',
        targetPositionId: targetPosition?.id,
        expertise: expertise ? expertise.name : '-',
        expertiseId: expertise?.id ?? null,
        department: department ? department.name : '-',
        departmentId: department?.id ?? null,
        unit: unit ? unit.name : '-',
        unitId: unit?.id ?? null,
        role: getAccountRole(role.name),
        requestStatus,
      }),
    );
}

export { convertToUserManagementTable };
